import api from "./api"

const fileUploadService = {
    uploadFile: async (payload) => {
        const response = await api.post('/api/file-upload', payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    },

    uploadJsonFile: async (file) => {
        const response = await api.post('/api/file-upload/json', file);
        return response.data;
    },
};

export default fileUploadService;